import transformer from '@common-vue/product-carousel/src/utils/Interface';
import { fetchSiteMonResponse } from '../services/siteMonXapi';
import minDetailProductThumbnail from '../utils/transformerUtil';
import priceSimplificationUtil from '../utils/priceSimplificationUtil';

export default async function useSponsoredData({
  clientId,
  parameters,
  device,
  loading,
  monetizationComponent,
  isSiteMonCallSuccessful,
  carouselTitle,
  sponsoredProducts,
  carouselBeacons,
  banner,
  store,
  isMcom,
  isSimplificationOnEnabled,
  selectedUpcId,
  collapsedProductDetails,
  sponsoredBrandResponse,
  showSponsoredLabel,
}) {
  const isSponsoredBrand = !(sponsoredBrandResponse === undefined);
  const isBrandShowcase = monetizationComponent === 'brand showcase' && !isSponsoredBrand;
  try {
    const siteMonResponse = await fetchSiteMonResponse(
      clientId,
      { ...parameters, isMcom },
      device,
      isBrandShowcase,
      selectedUpcId.value,
      sponsoredBrandResponse,
    );
    // all response object validation should be done in 'handleSiteMonResponse in siteMonXapi.js
    if (typeof siteMonResponse === 'object' && (siteMonResponse?.brandShowCase?.productPoolMedia || siteMonResponse?.productPoolMedia)) {
      const productPoolMedia = siteMonResponse?.brandShowCase?.productPoolMedia || siteMonResponse?.productPoolMedia;
      const { collection } = productPoolMedia;
      carouselBeacons.value = {
        onViewBeacon: productPoolMedia.onViewBeacon || '',
        onLoadBeacon: productPoolMedia.onLoadBeacon || '',
      };
      if (!isBrandShowcase && !isSponsoredBrand) {
        carouselTitle.value = siteMonResponse.productPoolMedia.poolLink.text;
        if (carouselTitle.value !== 'Sponsored items' && isMcom) showSponsoredLabel.value = true;
      } else {
        const media = siteMonResponse?.banner || siteMonResponse?.brandShowCase?.banner;
        const imageUrl = media.imagePath;
        /* istanbul ignore next */
        if (imageUrl.indexOf('https') === -1) {
          media.imagePath = `https:${imageUrl}`;
        }
        banner.value = media;
      }
      sponsoredProducts.value.push(...collection);
      if (isSimplificationOnEnabled) {
        sponsoredProducts.value.forEach((product) => {
          priceSimplificationUtil(product);
        });
      }
      const sponsoredItemTopEnabled = clientId === 'product' && parameters?.showSponsoredItemTop && productPoolMedia?.featuredProductEnabled;
      if (sponsoredItemTopEnabled) {
        const sponsoredItemTop = sponsoredProducts.value.shift();
        sponsoredItemTop.product.detail.flags.sponsoredItemTop = true;
        if (collapsedProductDetails) {
          const productSMData = sponsoredItemTop.product?.meta;
          sponsoredItemTop.product = transformer(sponsoredItemTop);
          sponsoredItemTop.product.meta = productSMData;
        }
        if (!isSimplificationOnEnabled) {
          delete sponsoredItemTop.product.pricing?.badges;
          delete sponsoredItemTop.product.pricing?.price?.priceType?.text;
        }
        store.dispatch('sponsoredItemTopStore/setSponsoredItemTop', sponsoredItemTop);
      }
      if (!isMcom) {
        sponsoredProducts.value.forEach((product) => {
          product.product = minDetailProductThumbnail(product);
        });
      }
      isSiteMonCallSuccessful.value = true;
    } else {
      throw new Error('Invalid Site Monetization Response');
    }
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  } finally {
    loading.value = false;
  }
  return {
    sponsoredProducts, banner, isSiteMonCallSuccessful, carouselTitle, carouselBeacons, showSponsoredLabel,
  };
}
